import React from "react";
import { globalFileServer, globalFileIcon } from "../../../axiosInstance";
import { NavLink } from "react-router-dom";
import ScrollReveal from "../ui/ScrollReveal";

const Footer = () => {
  return (
    <footer className="footer relative z-[1000] mt-16 border-t border-border bg-surface/90 text-foreground shadow-[0_-12px_40px_-28px_rgba(15,23,42,0.35)] backdrop-blur-xl transition-colors duration-layout dark:shadow-[0_-12px_40px_-28px_rgba(0,0,0,0.55)]">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-4 py-10 sm:px-6 lg:px-8">
        <ScrollReveal className="flex flex-col gap-4 border-b border-border pb-8 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-muted">
            <a
              target="_blank"
              className="rounded-card px-1 py-0.5 text-foreground underline-offset-4 transition-colors duration-layout hover:text-accent"
              href={globalFileServer + "med.pdf"}
              rel="noreferrer"
            >
              תקנון האתר
            </a>
            <span className="hidden text-muted/30 sm:inline">|</span>
            <a
              target="_blank"
              className="rounded-card px-1 py-0.5 text-foreground underline-offset-4 transition-colors duration-layout hover:text-accent"
              href={globalFileServer + "privacy.pdf"}
              rel="noreferrer"
            >
              מדיניות הפרטיות
            </a>
            <span className="hidden text-muted/30 sm:inline">|</span>
            <a
              target="_blank"
              className="rounded-card px-1 py-0.5 text-foreground underline-offset-4 transition-colors duration-layout hover:text-accent"
              href={globalFileServer + "accessibility.pdf"}
              rel="noreferrer"
            >
              הצהרת נגישות
            </a>
            <span className="hidden text-muted/30 sm:inline">|</span>
            <NavLink
              className="rounded-card px-1 py-0.5 text-foreground underline-offset-4 transition-colors duration-layout hover:text-accent"
              to="/workers-needed"
              target="_self"
              onClick={() => window.scrollTo(0, 0)}
            >
              דרושים
            </NavLink>
          </div>
        </ScrollReveal>

        <ScrollReveal
          className="grid gap-4 sm:grid-cols-3"
          rootMargin="0px 0px -5% 0px"
        >
          <a
            href="/"
            className="ui-card group flex flex-col items-center gap-3 text-center no-underline"
            onClick={(e) => e.preventDefault()}
          >
            <img
              loading="lazy"
              src={globalFileIcon + "hand-click.svg"}
              alt=""
              className="h-11 w-11 transition-transform duration-layout group-hover:scale-105"
            />
            <div>
              <h3 className="m-0 text-base font-bold text-accent">קליק וקיבלת</h3>
              <p className="m-1 mt-1 text-sm text-muted">24 שעות אצלך בבית</p>
            </div>
          </a>
          <a
            href="/"
            className="ui-card group flex flex-col items-center gap-3 text-center no-underline"
            onClick={(e) => e.preventDefault()}
          >
            <img
              loading="lazy"
              src={globalFileIcon + "chose-click.svg"}
              alt=""
              className="h-11 w-11 transition-transform duration-layout group-hover:scale-105"
            />
            <div>
              <h3 className="m-0 text-base font-bold text-accent">קליק ובחרת</h3>
              <p className="m-1 mt-1 text-sm text-muted">
                הכשרים מהודרים לכל המוצרים
              </p>
            </div>
          </a>
          <a
            href="/"
            className="ui-card group flex flex-col items-center gap-3 text-center no-underline"
            onClick={(e) => e.preventDefault()}
          >
            <img
              loading="lazy"
              src={globalFileIcon + "earn-click.svg"}
              alt=""
              className="h-11 w-11 transition-transform duration-layout group-hover:scale-105"
            />
            <div>
              <h3 className="m-0 text-base font-bold text-accent">קליק והרווחת</h3>
              <p className="m-1 mt-1 text-sm text-muted">עשרות מבצעים שווים!</p>
            </div>
          </a>
        </ScrollReveal>

        <ScrollReveal
          className="flex flex-col items-center justify-between gap-6 border-t border-border pt-8 sm:flex-row"
          rootMargin="0px 0px -3% 0px"
        >
          <div className="flex flex-col items-center gap-2 text-center sm:items-start sm:text-start">
            <img
              loading="lazy"
              src={globalFileIcon + "footer-site.svg"}
              alt="המזון"
              className="h-auto w-[min(200px,70vw)] opacity-90"
            />
            <span className="text-sm text-muted">
              כל הזכויות שמורות להמזון בע&quot;מ
            </span>
          </div>
        </ScrollReveal>
      </div>
    </footer>
  );
};
export default Footer;
